/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import { GetWeekendDay } from "../common/Common";

import circleLeftIcon from "../../img/icon/icon-circle-left.svg";
import circleRightIcon from "../../img/icon/icon-circle-right.svg";

const SetupCurrentDate = ({ varCurrentDate,onChangeCurrentDateHandler }) => {

  return (
    <div className="driving-calendar-head mb10">
      <div className="driving-calendar-controller">
        <div className="driving-calendar-prev" onClick={e=>onChangeCurrentDateHandler(e,-1)}><img src={circleLeftIcon} alt="" /></div>
        <div className="driving-calendar-value">
          <span className="driving-calendar-number">{varCurrentDate.getFullYear()}</span><span>&nbsp;년</span>
          <span className="driving-calendar-number">{varCurrentDate.getMonth()+1}</span><span>&nbsp;월</span>
          <span className="driving-calendar-number">{varCurrentDate.getDate()}</span><span>&nbsp;일</span>
          <span>&nbsp;({GetWeekendDay(varCurrentDate)})</span>
        </div>
        <div className="driving-calendar-next" onClick={e=>onChangeCurrentDateHandler(e,1)}><img src={circleRightIcon} alt="" /></div>
      </div>
    </div>
  );
}
export default SetupCurrentDate;